import(/* webpackMode: "eager", webpackExports: ["ArticleProgressBar"] */ "/app/apps/todoist-landing-pages/app/[locale]/productivity-methods/components/article-progress-bar/article-progress-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/todoist-landing-pages/app/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/todoist-landing-pages/app/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DraftModeBanner"] */ "/app/apps/todoist-landing-pages/components/draft-mode/draft-mode-banner.tsx");
